import ProductCompare from 'components/admin/Products/ProductCompare'
import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadPathLeaves, loadProductCategories } from 'redux/categories'
import { loadProductState } from 'redux/importer'
import { loadKeywords } from 'redux/keywords'
import { cancelConfirm } from 'redux/navigation'
import { disableForm, initializeCompareForm, loadProducts } from 'redux/product'
import { loadProperties } from 'redux/properties'
import { loadUsers } from 'redux/userAdmin'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadUsers,
      loadProperties,
      loadBreadcrumbs: loadPathLeaves,
      loadProductCategories,
      loadKeywords,
      loadProducts,
      disableForm,
      initializeCompareForm,
      loadProductState,
    },
    dispatch
  )
}

class ProductCompareContainer extends React.Component {
  componentWillMount() {
    const {
      match: { params: params = {} },
    } = this.props // react router
    const { initializeCompareForm, disableForm } = this.props
    if (params.article_number) {
      initializeCompareForm(params.article_number)
    } else disableForm()

    const {
      loadProducts,
      loadBreadcrumbs,
      loadProductCategories,
      loadKeywords,
      loadProperties,
      loadUsers,
      loadProductState,
    } = this.props
    loadProducts()
    loadBreadcrumbs()
    loadProductCategories()
    loadKeywords()
    loadProperties()
    loadUsers()
    loadProductState()
  }

  componentWillReceiveProps(nextProps) {
    const {
      match: { params: oldParams = {} },
      initializeCompareForm,
    } = this.props
    const {
      match: { params: newParams = {} },
    } = nextProps
    if (oldParams.article_number !== newParams.article_number) {
      initializeCompareForm(newParams.article_number)
    }
  }

  render() {
    return <ProductCompare />
  }
}

ProductCompareContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProductCompareContainer
)
export default ProductCompareContainer



// WEBPACK FOOTER //
// ./src/containers/admin/product_compare.jsx